import { render, staticRenderFns } from "./PageCrumbs.vue?vue&type=template&id=00887cae&scoped=true"
import script from "./PageCrumbs.vue?vue&type=script&lang=js"
export * from "./PageCrumbs.vue?vue&type=script&lang=js"
import style0 from "./PageCrumbs.vue?vue&type=style&index=0&id=00887cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00887cae",
  null
  
)

export default component.exports